/* @jsxImportSource react */

import type { ReactNode } from 'react';
import { SWRConfig } from 'swr';

import type { Device } from '@packages/shared/src/utils/types';
import type { Locale } from '@packages/config';
import { ErrorBoundary } from '@packages/shared/src/ui/ErrorBoundary/ErrorBoundary';

import { DefaultHeader } from './DefaultHeader';
import { MinimalHeader } from './MinimalHeader';
import { PaceId } from './PaceId';
import { SearchHistoryUpdater } from './SearchHistoryUpdater';
import { AbTestEnrollments } from './AbTestEnrollments';
import { SessionCartInfoTracking } from './SessionCartInfoTracking';
import { PersistentScrid } from './PersistentScrid';
import { PostLoginActionsHandler } from '../PostLoginActions/PostLoginActionsHandler.client';

export type HeaderProps = {
  locale: Locale;
  isMinimal?: boolean;
  device: Device;
  isPerformanceTest?: boolean;
  navigation?: ReactNode;
};

export const Header = ({
  locale,
  isMinimal,
  device,
  isPerformanceTest,
  navigation,
}: HeaderProps) => (
  <>
    {process.env.NODE_ENV !== 'development' && (
      <ErrorBoundary>
        <PaceId />
      </ErrorBoundary>
    )}
    <ErrorBoundary>
      <SessionCartInfoTracking />
    </ErrorBoundary>
    <ErrorBoundary>
      <PersistentScrid />
    </ErrorBoundary>

    <SWRConfig>
      <ErrorBoundary>
        <SearchHistoryUpdater />
      </ErrorBoundary>
      <ErrorBoundary>
        <AbTestEnrollments />
      </ErrorBoundary>
    </SWRConfig>

    <ErrorBoundary>
      <PostLoginActionsHandler />
    </ErrorBoundary>

    {isMinimal ? (
      <MinimalHeader />
    ) : (
      <DefaultHeader
        locale={locale}
        device={device}
        isPerformanceTest={isPerformanceTest}
        navigation={navigation}
      />
    )}
  </>
);
